import { Page } from '@/core/architecture'

import { CustomProfileEditAvatarTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * CustomProfileEditAvatar Page
 * Implemented as a practical sample.
 */
export const CustomProfileEditAvatar: Page = () => {
  const { state, actions } = useViewModel()

  return <CustomProfileEditAvatarTemplate state={state} {...actions} />
}
